import { styled } from '@volkswagen-onehub/components-core';
import React, { useContext } from 'react';
import useTrans from '../../hooks/use-trans';
import { AppContext } from '../../store/context/AppContext';

interface JellyInterface {
    model : string;
}

const JellyContainer = styled.div`
    text-align: center;

    img {
        width: 70%;
    }
`;

const Jelly : React.FC<JellyInterface> = ({model}) => {
    const context = useContext(AppContext);
    const trans = useTrans();

    return (
        <JellyContainer>
            <img src={context.imageBaseUrl + '/' + model + '.png'} alt={trans['vehicles_alt_' + model]} />
        </JellyContainer>
    );
}

export default Jelly;
